import React from 'react';
import './index.css';

function DropDown ({children, ...other}) {
	return (
		<ul className="drop-down" {...other}>
			{children}
		</ul>
	)
}

export default DropDown;
